// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#basket[data-v-b5638936]{background:#fff;border-radius:20px;margin:0 auto;max-width:450px;overflow:auto;padding:32px}#basket .basket_item[data-v-b5638936]{border-bottom:1px solid #000}@media screen and (max-width:500px){#basket[data-v-b5638936]{border-radius:0;padding:32px 0}}.card[data-v-b5638936]{background:#f2f5fa;border-radius:9px;margin:0 auto;max-width:400px;padding:2rem;width:80%}.rate-limit-error .error-icon[data-v-b5638936]{color:#3498db}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
